<p-table #dt [value]="getFileUploadStandardProcessArray"
styleClass="p-datatable-striped p-datatable-gridlines" [lazy]="true" [scrollable]="true" scrollHeight="400px"
[rowHover]="true" dataKey="Id" >
<ng-template pTemplate="header">
  <tr>
    <th style="min-width:200px">Name</th>
    <th>Document Type</th>
    <th>Date</th>
    <th style="width: 18%;">Action</th>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-getFileUploadStandardProcessArray let-rowIndex="rowIndex">
  <tr>
    <td class="surface-overlay border-round   white-space-nowrap overflow-hidden text-overflow-ellipsis"
      style="width:200px">
      {{getFileUploadStandardProcessArray.qfs_fileName}}
    </td>
    <td>
      {{getFileUploadStandardProcessArray.qfs_uploadedDocument}}
    </td>
    <td>
      {{getFileUploadStandardProcessArray.qfs_FileUploadingDate | date: 'MM/dd/yyyy'}}
    </td>
    <td>
      <p-image class="mr-2 cursor-pointer" src="../../../../../../../../assets/images/dowbload.svg" pTooltip="Download File"
        tooltipPosition="left"
        (click)="showDownloadDocument(rowIndex,'download', getFileUploadStandardProcessArray.qfs_fileName);$event.stopPropagation();"
        alt="Image" width="25px">
      </p-image>
      <div [style]="getFileUploadStandardProcessArray.wordFileDnone">
        <p-image class="mr-2 cursor-pointer" src="../../../../../../../../assets/images/view.svg" pTooltip="View File"
          tooltipPosition="bottom"
          (click)="showDownloadDocument(rowIndex,'show', getFileUploadStandardProcessArray.qfs_fileName);$event.stopPropagation();"
          alt="Image" width="25px"></p-image>
      </div>
      <p-image *ngIf="isAccessReadWrite && !roleForFacility" class="mr-2 cursor-pointer" pTooltip="Delete File" tooltipPosition="bottom"
        src="../../../../../../../../assets/images/Delete.svg"
        (click)="DeleteDownloadDocument(getFileUploadStandardProcessArray.qfs_Id);$event.stopPropagation();" alt="Image" width="25px">
      </p-image>
    </td>
  </tr>
</ng-template>
<ng-template pTemplate="emptymessage" let-columns>
  <tr>
    <h5 *ngIf="totalRecords==0" class="text-center create-roles">
      <b> No records found</b>
    </h5>
  </tr>
</ng-template>
</p-table>